document.querySelector('[data-discount-form]')?.addEventListener('submit',event=>{
  event.preventDefault();
  const code=new FormData(event.currentTarget).get('code').trim();
  if(code){
    const root=JSON.parse(document.getElementById('lind-config').textContent).root;
    location.href=root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(root+'cart');
  }
});

const chanterHandle='lindsay-system-chanter';
const pipesHandle='lindsay-system-scottish-smallpipes';
const pipesDepositHandle='lindsay-system-scottish-smallpipes-50-deposit';
const firstWorkshopDate='2026-10-12';
const lastWorkshopDate='2027-10-12';
const unavailableWorkshopDates=new Set(['2026-10-07','2026-10-08','2026-10-09','2026-10-10','2026-10-11']);
let preparedButton=null;
let preparedPipesButton=null;
let chanterPayment='full';
let chanterProductsPromise=null;
let pipeProductsPromise=null;

function onChanterPage(){return location.pathname.replace(/\/$/,'')==='/products/'+chanterHandle;}
function onPipesPage(){return location.pathname.replace(/\/$/,'')==='/products/'+pipesHandle;}
function isoDate(date){return date.toISOString().slice(0,10);}
function fromIso(value){return new Date(value+'T12:00:00Z');}
function longDate(value){return new Intl.DateTimeFormat('en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(fromIso(value));}
function shortDate(value){return new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',timeZone:'UTC'}).format(fromIso(value));}
function monthStart(date){return new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),1,12));}
function nearestWorkshopDate(){
  const minimum=fromIso(firstWorkshopDate);
  const today=new Date();
  let date=new Date(Date.UTC(today.getUTCFullYear(),today.getUTCMonth(),today.getUTCDate(),12));
  if(date<minimum)date=minimum;
  const maximum=fromIso(lastWorkshopDate);
  while(date<=maximum&&unavailableWorkshopDates.has(isoDate(date)))date.setUTCDate(date.getUTCDate()+1);
  return date<=maximum?isoDate(date):'';
}
function addCalendarMonths(date,count){
  const first=new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth()+count,1,12));
  const lastDay=new Date(Date.UTC(first.getUTCFullYear(),first.getUTCMonth()+1,0,12)).getUTCDate();
  first.setUTCDate(Math.min(date.getUTCDate(),lastDay));
  return first;
}
function pipeBlackout(date){
  return (date.getUTCMonth()===11&&date.getUTCDate()>=21)||(date.getUTCMonth()===0&&date.getUTCDate()<=6);
}
function pipeSchedule(){
  const now=new Date();
  const today=new Date(Date.UTC(now.getUTCFullYear(),now.getUTCMonth(),now.getUTCDate(),12));
  const regular=addCalendarMonths(today,3);
  const christmas=now.getUTCMonth()===8;
  const christmasStart=new Date(Date.UTC(now.getUTCFullYear(),11,1,12));
  const christmasEnd=new Date(Date.UTC(now.getUTCFullYear(),11,7,12));
  const first=christmas?christmasStart:regular;
  const maximum=addCalendarMonths(regular,12);
  const isAvailable=(value,date)=>{
    if(pipeBlackout(date))return false;
    if(christmas&&date>=christmasStart&&date<=christmasEnd)return true;
    return date>=regular;
  };
  let nearest=new Date(first);
  while(nearest<=maximum&&!isAvailable(isoDate(nearest),nearest))nearest.setUTCDate(nearest.getUTCDate()+1);
  return{first:isoDate(first),last:isoDate(maximum),nearest:isoDate(nearest),isAvailable};
}
function money(cents){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(cents/100);}
function productJson(handle){
  const root=JSON.parse(document.getElementById('lind-config').textContent).root;
  return fetch(root+'products/'+handle+'.js',{credentials:'same-origin'}).then(response=>{
    if(!response.ok)throw new Error('The live product options could not be loaded.');
    return response.json();
  });
}
function chanterProducts(){
  return chanterProductsPromise||(chanterProductsPromise=Promise.all([
    productJson(chanterHandle),
    productJson('lindsay-system-chanter-deposit')
  ]).then(([full,deposit])=>({full,deposit})).catch(error=>{chanterProductsPromise=null;throw error;}));
}
function pipeProducts(){
  return pipeProductsPromise||(pipeProductsPromise=Promise.all([
    productJson(pipesHandle),
    productJson(pipesDepositHandle)
  ]).then(([full,deposit])=>({full,deposit})).catch(error=>{pipeProductsPromise=null;throw error;}));
}

function makeWorkshopCalendar(onChoose,settings={}){
  const dialog=document.createElement('dialog');
  dialog.className='workshop-calendar';
  dialog.innerHTML='<div class="workshop-calendar-top"><div><p class="eyebrow">'+(settings.eyebrow||'Your chanter')+'</p><h2 id="workshopCalendarTitle">Choose a dispatch date</h2></div><button type="button" class="workshop-calendar-close" aria-label="Close calendar">×</button></div><div class="workshop-month-nav"><button type="button" class="workshop-previous" aria-label="Previous month">‹</button><strong aria-live="polite"></strong><button type="button" class="workshop-next" aria-label="Next month">›</button></div><div class="workshop-weekdays" aria-hidden="true"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div><div class="workshop-days" role="grid"></div><p class="workshop-legend"><span><i></i>Available</span><span><i></i>Unavailable</span></p><p class="muted">'+(settings.note||'Choose the day your finished chanter will leave the workshop. Need a later date? Ask Donald.')+'</p>';
  dialog.setAttribute('aria-labelledby','workshopCalendarTitle');
  document.body.append(dialog);
  const label=dialog.querySelector('.workshop-month-nav strong');
  const grid=dialog.querySelector('.workshop-days');
  const previous=dialog.querySelector('.workshop-previous');
  const next=dialog.querySelector('.workshop-next');
  const minimum=fromIso(settings.first||firstWorkshopDate);
  const maximum=fromIso(settings.last||lastWorkshopDate);
  let shown=monthStart(minimum);

  function render(){
    label.textContent=new Intl.DateTimeFormat('en-GB',{month:'long',year:'numeric',timeZone:'UTC'}).format(shown);
    grid.replaceChildren();
    const mondayOffset=(shown.getUTCDay()+6)%7;
    for(let blank=0;blank<mondayOffset;blank++)grid.append(document.createElement('span'));
    const year=shown.getUTCFullYear();
    const month=shown.getUTCMonth();
    const daysInMonth=new Date(Date.UTC(year,month+1,0)).getUTCDate();
    for(let day=1;day<=daysInMonth;day++){
      const date=new Date(Date.UTC(year,month,day,12));
      const value=isoDate(date);
      const available=date>=minimum&&date<=maximum&&(settings.isAvailable?settings.isAvailable(value,date):!unavailableWorkshopDates.has(value));
      const button=document.createElement('button');
      button.type='button';
      button.textContent=String(day);
      button.disabled=!available;
      button.dataset.date=value;
      button.setAttribute('role','gridcell');
      button.setAttribute('aria-label',longDate(value)+(available?'':' — unavailable'));
      if(available)button.addEventListener('click',()=>{onChoose(value);dialog.close();});
      grid.append(button);
    }
    previous.disabled=shown<=monthStart(minimum);
    next.disabled=shown>=monthStart(maximum);
  }

  previous.addEventListener('click',()=>{shown=new Date(Date.UTC(shown.getUTCFullYear(),shown.getUTCMonth()-1,1,12));render();});
  next.addEventListener('click',()=>{shown=new Date(Date.UTC(shown.getUTCFullYear(),shown.getUTCMonth()+1,1,12));render();});
  dialog.querySelector('.workshop-calendar-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  render();
  return dialog;
}

async function preparePipeBooking(){
  if(!onPipesPage())return;
  const button=document.querySelector('#addToBag');
  const variant=document.querySelector('#variant');
  const payment=document.querySelector('#payment');
  if(!button||!variant||!payment||button===preparedPipesButton)return;
  preparedPipesButton=button;
  let products;
  try{products=await pipeProducts();}catch(error){preparedPipesButton=null;return;}
  if(!button.isConnected||!variant.isConnected)return;
  const originalLabel=variant.closest('label');
  const selected=products.full.variants.find(item=>String(item.id)===String(variant.value))||products.full.variants[0];
  const optionNames=products.full.options||[];
  if(optionNames.length>=2&&selected){
    const selectors=optionNames.map((name,index)=>{
      const label=document.createElement('label');
      const select=document.createElement('select');
      label.append(typeof name==='string'?name:name.name,select);
      [...new Set(products.full.variants.map(item=>item.options[index]))].forEach(value=>select.add(new Option(value,value,value===selected.options[index],value===selected.options[index])));
      return{label,select,index};
    });
    originalLabel.hidden=true;
    selectors.forEach(item=>originalLabel.before(item.label));
    selectors.forEach(item=>item.select.addEventListener('change',()=>{
      const values=selectors.map(control=>control.select.value);
      const match=products.full.variants.find(candidate=>candidate.options.every((value,index)=>value===values[index]));
      if(match){variant.value=String(match.id);variant.dispatchEvent(new Event('change',{bubbles:true}));}
    }));
  }
  const field=document.createElement('div');
  field.className='workshop-date-field pipe-dispatch-field';
  field.textContent='Made to order. Please enquire for current delivery timing.';
  button.before(field);
  const replacement=button.cloneNode(true);
  replacement.textContent='Order your pipes';
  button.replaceWith(replacement);
  preparedPipesButton=replacement;
  replacement.addEventListener('click',async event=>{
    event.preventDefault();
    replacement.disabled=true;
    replacement.textContent='Booking…';
    try{
      const fullVariant=products.full.variants.find(item=>String(item.id)===String(variant.value));
      const orderVariant=payment.value==='deposit'?products.deposit.variants.find(item=>item.title===fullVariant?.title):fullVariant;
      if(!orderVariant||!orderVariant.available)throw new Error('That pipe-set configuration is not currently available.');
      const finish=fullVariant.options[1];
      const root=JSON.parse(document.getElementById('lind-config').textContent).root;
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(orderVariant.id),quantity:1,properties:{'Delivery timing':'To be confirmed individually','Mount finish':finish,'Case':fullVariant.options[2]||'No case','Payment':payment.value==='deposit'?'50% deposit':'Paid in full'}}]})});
      const body=await response.json();
      if(!response.ok)throw new Error(body.description||body.message||'That pipe-set configuration is no longer available.');
      location.href=root+'cart';
    }catch(error){
      replacement.disabled=false;
      replacement.textContent='Order your pipes';
      const toast=document.querySelector('#toast');
      if(toast)toast.textContent=error.message;else alert(error.message);
    }
  });
}

const chanterCampaignCutoff=Date.parse('2026-11-01T00:00:00Z');
const chanterCampaignDispatch='2026-10-22';
const chanterCampaignPromise='Current batch: five chanters available, ready for final testing. Expected dispatch from 22 October 2026, following clearance of the remaining back orders. Existing orders remain our first priority.';
const chanterCampaignClosed='Ask Donald about availability and the next dispatch date before ordering.';
function chanterCampaignOpen(now=Date.now()){return Number.isFinite(now)&&now<chanterCampaignCutoff;}
function chanterCampaignProperties(finish,payment){
  return {'Workshop dispatch date':'22 October 2026 (expected, current batch)','Dispatch offer':'Current batch of five chanters — availability updated 15 October 2026','Mount finish':finish,'Payment':payment==='deposit'?'50% deposit':'Paid in full'};
}
function refreshChanterCampaignCopy(){
  if(!onChanterPage())return;
  const open=chanterCampaignOpen(),state=open?'open':'closed';
  const panel=document.querySelector('.fulfilment-panel');
  if(panel&&panel.dataset.chanterCampaign!==state){
    panel.dataset.chanterCampaign=state;
    panel.innerHTML='<p class="eyebrow">Current batch · five chanters available</p><p><strong>'+(open?chanterCampaignPromise:chanterCampaignClosed)+'</strong></p><p class="muted">Dispatch is when your chanter leaves the workshop. Arrival depends on the delivery service and destination.</p><p class="muted">If the proposed timing is unsuitable, you can cancel for a full refund. If you need the chanter for a particular occasion, ask before ordering.</p>';
  }
  const field=document.querySelector('[data-chanter-campaign-field]');
  if(field&&field.dataset.chanterCampaignState!==state){
    field.dataset.chanterCampaignState=state;
    field.innerHTML=open?'<span>Expected dispatch from </span><strong><time datetime="2026-10-22">22 October 2026</time></strong><p class="muted">Current batch of five chanters — availability updated 15 October 2026</p>':'<p>'+chanterCampaignClosed+'</p><a class="text-link" href="mailto:lindstruments@gmail.com">Ask Donald</a>';
  }
  const button=document.querySelector('#addToBag');
  if(button?.dataset.chanterCampaignButton==='true'&&!open){
    button.disabled=true;
    if(button.textContent!=='Ask Donald about the next dispatch')button.textContent='Ask Donald about the next dispatch';
  }
}
function prepareWorkshopBooking(){
  if(!onChanterPage())return;
  refreshChanterCampaignCopy();
  const button=document.querySelector('#addToBag');
  const variant=document.querySelector('#variant');
  if(!button||!variant||button===preparedButton)return;
  document.querySelector('.workshop-date-field')?.remove();
  document.querySelector('.commission-order-note')?.remove();
  document.querySelector('.workshop-calendar')?.remove();
  document.querySelector('.chanter-payment-field')?.remove();
  const variantLabel=variant.closest('label');
  if(variantLabel&&variantLabel.firstChild?.nodeType===Node.TEXT_NODE)variantLabel.firstChild.nodeValue='Mount finish';
  const paymentField=document.createElement('label');
  paymentField.className='chanter-payment-field';
  paymentField.innerHTML='Payment<select id="chanterPayment"><option value="full">Pay in full</option><option value="deposit">Pay 50% deposit</option></select>';
  paymentField.querySelector('select').value=chanterPayment;
  variantLabel?.after(paymentField);
  const field=document.createElement('div');
  field.className='workshop-date-field';
  field.dataset.chanterCampaignField='true';
  button.before(field);
  const replacement=button.cloneNode(true);
  replacement.dataset.chanterCampaignButton='true';
  replacement.textContent='Order your chanter · expected dispatch from '+shortDate(chanterCampaignDispatch);
  replacement.disabled=!chanterCampaignOpen()||variant.selectedOptions[0]?.disabled===true;
  button.replaceWith(replacement);
  const explanation=document.createElement('p');
  explanation.className='muted commission-order-note';
  explanation.textContent='Your order is for the complete Lindsay System chanter, individually made, set up and tested by Donald.';
  replacement.after(explanation);
  const summary=document.querySelector('.money-summary');
  let products=null;
  function selectedFinish(){return variant.selectedOptions[0]?.textContent.split(' · ')[0].trim()||'All black';}
  function renderPayment(){
    if(!products)return;
    const finish=selectedFinish();
    const full=products.full.variants.find(item=>String(item.id)===String(variant.value))||products.full.variants.find(item=>item.title===finish);
    const deposit=products.deposit.variants.find(item=>item.title===finish);
    if(!full||!deposit)return;
    if(summary)summary.innerHTML=chanterPayment==='deposit'
      ?'<p><span>Full instrument price</span><strong>'+money(full.price)+'</strong></p><p><span>Deposit now</span><strong>'+money(deposit.price)+'</strong></p><p><span>Balance before dispatch</span><strong>'+money(full.price-deposit.price)+'</strong></p>'
      :'<p><span>Full instrument price</span><strong>'+money(full.price)+'</strong></p><p><span>Pay now</span><strong>'+money(full.price)+'</strong></p>';
  }
  chanterProducts().then(value=>{products=value;renderPayment();}).catch(error=>{
    const toast=document.querySelector('#toast');if(toast)toast.textContent=error.message;
  });
  paymentField.querySelector('select').addEventListener('change',event=>{chanterPayment=event.target.value;renderPayment();});
  variant.addEventListener('change',renderPayment);
  preparedButton=replacement;
  refreshChanterCampaignCopy();
  replacement.addEventListener('click',async event=>{
    event.preventDefault();
    if(!chanterCampaignOpen()){refreshChanterCampaignCopy();return;}
    replacement.disabled=true;
    replacement.textContent='Adding…';
    try{
      const root=JSON.parse(document.getElementById('lind-config').textContent).root;
      if(!products)products=await chanterProducts();
      const finish=selectedFinish();
      const fullVariant=products.full.variants.find(item=>String(item.id)===String(variant.value))||products.full.variants.find(item=>item.title===finish);
      const depositVariant=products.deposit.variants.find(item=>item.title===finish);
      const orderVariant=chanterPayment==='deposit'?depositVariant:fullVariant;
      if(!fullVariant?.available||!orderVariant?.available)throw new Error('That finish is not available on the selected payment route.');
      if(!chanterCampaignOpen())throw new Error(chanterCampaignClosed);
      const response=await fetch(root+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(orderVariant.id),quantity:1,properties:chanterCampaignProperties(finish,chanterPayment)}]})
      });
      const body=await response.json();
      if(!response.ok)throw new Error(body.description||body.message||'The chanter could not be added. Check your basket before trying again.');
      location.href=root+'cart';
    }catch(error){
      replacement.disabled=!chanterCampaignOpen();
      replacement.textContent=chanterCampaignOpen()?'Order your chanter · expected dispatch from '+shortDate(chanterCampaignDispatch):'Ask Donald about the next dispatch';
      const toast=document.querySelector('#toast');if(toast)toast.textContent=error.message;else alert(error.message);
    }
  });
}


function completePipeContents(){
  if(!onPipesPage()||location.hash!=='#contents')return;
  const panel=document.querySelector('.stage-text');
  if(!panel||panel.dataset.completePipeContents==='true')return;
  const heading=panel.querySelector('h3');
  const details=panel.querySelector('[data-details]');
  if(!heading||heading.textContent.trim()!=='What you receive'||!details)return;
  [...panel.children].forEach(child=>{if(child!==heading&&child!==details)child.remove();});
  const content=document.createElement('template');
  content.innerHTML='<p><strong>The standard set contains:</strong></p><ul><li><strong>Lindsay System chanter</strong> — full-spec, fully tuneable, keyless and extended-range.</li><li><strong>Cane chanter reed by Iain Allen</strong> — individually matched and set up with the chanter.</li><li><strong>Four Lindsay System drones</strong> — bass A/B, baritone D/E, tenor A/B and alto D/E.</li><li><strong>Four Eezedrone drone reeds</strong> — included, fitted and balanced as a complete set.</li><li><strong>Canmore Hybrid bag</strong> — stable, airtight and low-maintenance.</li><li><strong>Scottish smallpipe bellows.</strong></li><li><strong>Bag cover by Debbie Covers &amp; Crafts.</strong></li><li><strong>Two Allen keys</strong> — stored on the chanter for its tuning controls.</li><li><strong>Complete matching chanter split-stock assembly</strong> — included in the complete set; no separate £50 stock charge.</li></ul><p><strong>Built into the system:</strong></p><ul><li>Full brass drone linings.</li><li>Long two-tone tuning slides and chamberless tone top-slides.</li><li>Individual O-ring-sealed drone caps.</li><li>Non-tying, screw-threaded bag stocks and sealed joints.</li><li>Global drone shutoff, separate airflow needle valve and dynamic ball-stop shutoff.</li><li>Separating main and cup stock for straightforward internal access.</li><li>Blowstock with replaceable umbrella valve.</li></ul><p><strong>Also included:</strong> the digital Smallpipes Field Guide, Learning App access on release, and email support. Questions before or after purchase are welcome at <a href="mailto:lindstruments@gmail.com">lindstruments@gmail.com</a>.</p><p>Already own a Lindsay chanter or suitable bellows? Choose the corresponding deduction when configuring your set.</p><p class="muted">Existing customers retain the support already promised with their orders.</p>';
  details.before(content.content);
  panel.dataset.completePipeContents='true';
}

function completeChanterContents(){
  if(!onChanterPage()||location.hash!=='#contents')return;
  const panel=document.querySelector('.stage-text');
  if(!panel||panel.dataset.completeChanterContents==='true')return;
  const heading=panel.querySelector('h3');
  const firstItem=panel.querySelector('ul li');
  if(!heading||heading.textContent.trim()!=='Contents & fit'||!firstItem)return;
  firstItem.innerHTML='<strong>Lindsay System chanter</strong> — fully tuneable, keyless and extended-range.';
  const reed=Array.from(panel.querySelectorAll('ul li')).find(li=>li.textContent.includes('Cane chanter reed by Iain Allen'))||document.createElement('li');
  reed.innerHTML='<strong>Cane chanter reed by Iain Allen</strong> — individually matched and set up with the chanter.';
  firstItem.after(reed);
  panel.dataset.completeChanterContents='true';
}

new MutationObserver(()=>{prepareWorkshopBooking();preparePipeBooking();completePipeContents();completeChanterContents();}).observe(document.body,{childList:true,subtree:true});
window.addEventListener('hashchange',()=>{prepareWorkshopBooking();preparePipeBooking();completePipeContents();completeChanterContents();});
prepareWorkshopBooking();
preparePipeBooking();
completePipeContents();
completeChanterContents();

window.addEventListener("focus",refreshChanterCampaignCopy);
document.addEventListener("visibilitychange",refreshChanterCampaignCopy);



